// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k6kla","question":"styles_question__2n6Sm","description":"styles_description__2Aw4G"};